import { combineReducers } from 'redux-immutable'
import reducerRegistry from '../reducerRegistry'
import multireducer from 'multireducer/immutable'
import session from './session'
import topic from './topic'
import entities from './entities'
import profile from './profile'
import journey from './journey'
import grandmaster from './grandmaster'
import search from './search'
import modal from './modal'
import content from './content'
import ui from './ui'
import entryTopicTitles from './entryTopicTitles'
import searchSuggestions from './searchSuggestions'
import topicFlatMap from './topicFlatMap'
import toast from './toast'


reducerRegistry.register('session', session)
reducerRegistry.register('journey', journey)
reducerRegistry.register('toast', toast)
reducerRegistry.register('topic', topic)
reducerRegistry.register('topicFlatMap', topicFlatMap)
reducerRegistry.register('entities', entities)
reducerRegistry.register('grandmaster', grandmaster)
reducerRegistry.register('search', search)
reducerRegistry.register('searchSuggestions', searchSuggestions)
reducerRegistry.register('modal', modal)
reducerRegistry.register('ui', ui)
reducerRegistry.register('profile', profile)
reducerRegistry.register('contentCollection', multireducer({
  leafExplanation: content,
  leafProblem: content,
  leafSolution: content,
  grandmasterProblem: content,
  grandmasterSolution: content,
  grandmasterExplanation: content
}))
reducerRegistry.register('entryTopicTitles', entryTopicTitles)

const rootReducer = combineReducers({
  session,
  journey,
  toast,
  topic,
  topicFlatMap,
  entities,
  grandmaster,
  search,
  searchSuggestions,
  modal,
  ui,
  profile,
  contentCollection: multireducer({
    leafExplanation: content,
    leafProblem: content,
    leafSolution: content,
    grandmasterProblem: content,
    grandmasterSolution: content,
    grandmasterExplanation: content
  }),
  entryTopicTitles
})
export default rootReducer



// WEBPACK FOOTER //
// ./src/redux/modules/reducer.js